const en = {
  // 로딩
  loading: 'Loading...',
  // 로그인
  welcome: 'Welcome',
  home: 'Home',
  login: 'Login',
  email: 'Email',
  password: 'Password',
  signUp: 'Sign Up',
  findPassword: 'Find Password',
  thisLoginIsForPartnerOnlyToPlayer:
    'This login is for Partners only.\nPlease install the PingPong App to log in as a Player.',
  thisLoginIsForPartnerOnly: 'This login is for Partners only.',
  enterTheEmailToBeUsedAsYourId: 'Enter the email to be used as your ID',
  pleaseEnterAcombinationOfInput:
    'Please enter a combination of letters, numbers, and special characters with a minimum length of 8 characters.',
  pleaseEnterAcombination:
    '* Please enter a combination of letters, numbers, and special characters with a minimum length of 8 characters.',
  pleaseEnterTheEmail: '* Please enter the email.',
  pleaseEnterAvalidEmailAddress: '* Please enter a valid email address.',
  theInputValueIsNotValid: 'The input value is not valid.',
  pleaseEnterYourPassword: '* Please enter your password.',
  pleaseEnterYourEmail: '* Please enter your email.',
  invalidEmailOrPassword:
    'Invalid email or password.\nPlease check your email and password and try again.',
  // 페이지네이션
  prev: 'Prev',
  next: 'Next',
  // 네이게이션(사이드바)
  failedLoadPartnerProfile: 'Failed to load partner profile.',
  // 주문 상태
  registeredStatus: 'Registered',
  accept: 'Accept',
  acceptApproved: 'Accept Approved',
  acceptPending: 'Pending',
  acceptRejected: 'Accept Rejected',
  canceled: 'Canceled',
  designConfirmRequested: 'Design Confirm Requested',
  closed: 'Closed',
  workProcessing: 'Work Processing',
  moreSearchResults: 'More Search Results',
  // 주문 목록 페이지, 완료된 주문 목록 페이지
  searchByOrderNameClinicNameOrPatientName:
    'Search by order name, clinic name, or patient name',
  orderDateBySorting: 'Order Date',
  dueDateBySorting: 'Due Date',
  completionDate: 'Completion Date',
  close: 'Close',
  more: 'More..',
  failedToChangeOrderStatus: 'Failed to change order status.',
  failedToLoadOrderList: 'Failed to load order list.',
  failedToLoadCompletedOrderList: 'Failed to load completed order list.',
  // 주문 상세
  orderDetailAndComment: 'Order Detail Comment',
  fileUpload: 'File Upload',
  history: 'History',
  youCanUploadMaximumOf5ItemsPerCategory:
    'You can upload a maximum of 5 items per category.',
  thereAreNoAttachments: 'There are no attachments.',
  thereAreNoProjectFilesUploaded: 'There are no project files uploaded.',
  thereAreNoStlFilesUploaded: 'There are no STL files uploaded.',
  thereAreNoEtcFilesUploaded: 'There are no etc files uploaded.',
  thereIsNoOrderHistory: 'There is no order history.',
  disabled: 'Disabled',
  failedToUploadFile: 'Failed to upload file.',
  failedToDeleteFile: 'Failed to delete file.',
  failedLoadOrderDetail: 'Failed to load order detail.',
  downloadAllFiles: 'Download all files',
  youCanUploadUpTo10Images: 'You can upload up to 10 files',
  unsupportedFileFormat: 'Unsupported file format.',
  fileNameGuide: 'File Name Guide',
  playerRevisionUploaded:
    'Player revision uploaded. Please review the changes.',
  finalConfirmedFilesByThePlayer: 'Final confirmed files by the player.',
  // 주문자 목록
  searchByOrdererIdOrName: 'Search by orderer ID or name',
  failedToLoadOrdererList: 'Failed to load orderer list.',
  // 고객센터
  qrCodeScan: 'QR Code Scan',
  megagenDigitalLibrary: 'MegaGen Digital Library',
  theLatestMegagenImplantLibraryIsAvailable:
    'The latest MegaGen Implant library is available.\nYou can download the library using the button below.',
  // 서비스 등록
  // 404
  thePageIsUnavailable: 'The page is unavailable',
  thePageYouAreLookingForDoesNotExistOrIsCurrentlyUnavailable:
    'The page you are looking for does not exist or is currently unavailable.',
  pleaseCheckTheAddressYouEnteredOnceAgain:
    'Please check the address you entered once again.',
  goToHome: 'Go to Home',
  // navbar
  dashboard: 'Dashboard',
  orderList: 'Order List',
  completedOrder: 'Completed Order',
  myPlayer: 'My Player',
  businessProfile: 'Business Profile',
  addProductService: 'Add Service',
  customerCenter: 'Customer Center',
  logout: 'Log out',
  // 메인 페이지
  theR2PlayersFromAllAroundTheWorldAreWaitingForYou:
    'The R2Players from all around the world are waiting for you to join.',
  myReviews: 'My Reviews',
  ReceivedOrders: 'Received Orders',
  yourBusinessProfileHasNotBeenSetUpYet:
    'Your business profile has not been set up yet.\nWould you like to set up your business profile\nnow?',
  noRegisteredServices: 'No registered services.\nRegister a service now?',
  goTo: 'Go to',
  // 주문 목록 페이지
  orderNo: 'Order No.',
  patient: 'Patient',
  orderType: 'Order Type',
  orderDate: 'Order Date',
  dueDate: 'Due Date',
  status: 'Status',
  orderDetail: 'Order\nDetail',
  reject: 'Reject',
  cancel: 'Cancel',
  reasonForRejection: 'Reason for Rejection',
  orders: 'Orders',
  // 주문 상세
  orderOptions: 'Order Options',
  designDiagnosisFile: 'Design(Diagnosis) File',
  customerConfirmationFile: 'Customer Confirmation File',
  attachedFile: 'Attached File',
  workLog: 'Work Log',
  onlyFilesAreSupported: 'Only {{type}} files<br/>are supported.',
  fileUploadLimitfileSizeMustBeMbOrLess:
    'File Upload Limit\nFile size must be {{size}} or less.',
  newOrderReceived: 'New order received.',
  orderReceivedInProgressPartner: 'Order received & in progress.',
  orderWasRejected: 'Order was rejected.',
  orderCancelled: 'Order Cancelled.',
  fileUploadCompletedSuccessfully: 'File upload completed successfully.',
  checkUserConfirmationFile: 'Check “User confirmation file”.',
  theDesignDiagnosisFileHasBeenDeleted:
    'The design(diagnosis) file has been deleted.',
  orderCompleted2: 'Order Completed.',
  designDiagnosisFileUploadedSuccessfully:
    'Design (diagnosis) file uploaded successfully.',
  confirmRevisionFileUploadedSuccessfully:
    'Confirm(Revision) file uploaded successfully.',
  // 나의 플레이어
  nation: 'Nation',
  contact: 'Contact',
  address: 'Address',
  registration: 'Registration',
  chat: 'Chat',
  people: 'People',
  comingSoon: 'Coming Soon',
  // 비즈니스 프로필
  accountInfo: 'Account Info',
  profileSettings: 'Profile Settings',
  imagesWillBeAppliedIn100x100Size: 'Images will be applied in 100x100 size.',
  fileFormatsJpegJpgPngBmpMaxSize20mb:
    'File formats: JPEG (JPG), PNG, BMP<br/> Max size: 20MB',
  nationality: 'Nationality',
  contactNo: 'Contact No.',
  r2Center: 'R2Center',
  r2Planner: 'R2Planner',
  officeNo: 'Office No.',
  businessAddress: 'Business\nAddress',
  serviceLanguage: 'Service\nLanguage',
  introduction: 'Introduction',
  businessHours: 'Business\nHours',
  representativeImages: 'Representative\nimages',
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  pleaseSetYourReqularBusinessHours:
    'Please set your regular business hours.\nDuring the specified hours,\nyour status will automatically change to [Open]',
  pleaseUploadAnImageThatRepresentsYourCenter:
    'Please upload an image that represents your center (planner).',
  youCanUploadUpTo5Images: 'You can upload up to 5 images.',
  fileFormatsJpegJpgPngBmpTiffSize1gb:
    'File formats: JPEG/JPG, PNG, Bmp, TIFF / Max size: 1GB',
  save: 'Save',
  representative: 'Representative',
  youveExceededTheImageUploadLimit:
    "You've exceeded the image upload limit.\nPlease delete some images and try again",
  // 고객센터
  scanTheQrCodeToChatWithUsOnYourFavoriteMessengerApp:
    'Scan the QR code to chat with us on your favorite messenger app',
  scanTheQRCodeUsingYourPhonesCamera:
    "Scan the QR code using your phone's camera.",
  tapTheIconOfYourPreferredChatAppAndSendUsYourInquiry:
    'Tap the icon of your preferred chat app and send us your inquiry.',
  // 서비스 등록
  registerTheServicesYouWantToOfferToR2Players:
    "Register the services you want to offer to R2 Players.\nTurn 'ON' to select detailed options or create your own.",
  manufacturingDesign: 'Manufacturing & Design',
  youCanRegisterManufacturingAndDesignServicesForCrownBridgeAndR2Guid:
    'You can register manufacturing and design\nservices for Crown & Bridge and R2 Guide',
  youCanSelectCrownBridgeAndR2GuideServices:
    'You can select Crown & Bridge and R2 Guide services.\nDesign Only is applied as the default, allowing design and\ndiagnostic services only.',
  exclusiveCenterServiceRegistration: 'Exclusive Center Service Registration',
  theseServicesAreExclusivelyAvailableOnlyAtCertifiedCenters:
    'These services are exclusively available only at certified centers.\nIf you would like to register exclusive center services, please contact the R2Playground Operations Team.',
  registerVariousManufacturingAndDesignServicesSuchAsCrownsInlaysOnlaysAndImplantProsthetics:
    'Register various manufacturing and design services such as crowns, inlays/onlays, and implant prosthetics.\nIf needed, you can freely create and add prosthetic types or materials under "Additional Options."',
  defaultOptions: 'Default Options',
  clickTheOptionButtonOnTheRightToActivateIt:
    'Click the option button on the right to activate it.',
  allDefaultOptionsCanBeSelectedSimultaneously:
    'All default options can be selected simultaneously,\nbut cannot be deleted or modified.',
  afterSelectingTheDefaultOptions:
    'After selecting the default options,\nyou must click the Save button to activate\nthe service.',
  addService: 'Add Service',
  ifYouNeedToAddServiceOptions:
    'If you need to add service options, enter the\nservice name and click the Add button.\n(Up to 10)',
  afterAddingServices:
    'After adding services,\nyou must click the Save button to activate them.',
  designService: 'Design Service',
  theDesignServceProvidesDesignOnlyWithout:
    'The Design Service provides design only without\nproceeding with prosthetic manufacturing',
  ifYouWouldLikeToOfferProstheticDeisgnService:
    'If you would like to offer prosthetic design services\nfor in-lab Players, please turn this option ON',
  enterTheServiceNameAndClickThe:
    'Enter the service name and click the “+” button.',
  designOnlyDesignServiceOnly: 'Design Only(Design service only.)',
  chooseTheServiceToProvideToThePlayer:
    'Choose the service to provide to the player from the default options or add a new one, then click Save.',
  designOnly: 'Design Only',
  oneDayImplantServicesWithR2GateDiagnosis:
    'ONE-DAY Implant services with R2GATE diagnosis, R2 Guide or R2 Real Navi, and Provisional.\nYour expertise leads to the success of R2players.',
  qvdDigitalDiagnostcServiceForEdentulousCases:
    'QVD - Digital Diagnostic Service for Edentulous Cases\nBased on R2studioQ data, QVD generates a Dental Avatar and determines the optimal VD through smile simulation.\nServices include: Dental Avatar · Smile Creator · QVD · Stackable Guide · Provisional Prosthesis',
  fromOrthognathicSurgeryToMaxillofacialProsthetics:
    'From orthognathic surgery to maxillofacial prosthetics,\nFaceGIDE delivers customized solutions based on precise diagnostics and surgical planning.',
  megAlignerClearAlignerServiceWithImplant:
    'MegAligner - Clear Aligner Service with Implant & Prosthetic Treatmen\nEsthetics are not achieved by restoring individual teeth alone. MegAligner combines general\ntreatment with clear aligners to create beautiful smiles and increase patient satisfaction.',
  // 모달
  confirm: 'Confirm',
  wouldYouLikeToRejectThisOrder: 'Would you like to reject this order?',
  pleaseEnterTheReasonForRejectingTheOrder:
    'Please enter the reason for rejecting the order.',
  done: 'Done',
  failedToconnectTotheServerPleaseTryAgainLater:
    'Failed to connect to the server.\nPlease try again later.',
  // 중복되는 다국어
  pending: 'Pending',
  pending2: 'Pending',
  inProgress: 'In Progress',
  inProgress2: 'In Progress',
  completed: 'Completed',
  completed2: 'Completed',
  clinic: 'Clinic',
  clinic2: 'Clinic',
  name: 'Name',
  name2: 'Name',
  id: 'ID',
  id2: 'ID',
  modify: 'Modify',
  modify2: 'Modify',
};

export default en;
